export const NativeCachedImageResizeMode = null;
export const NativeCachedImagePriority = null;
